import axios from './axios'

export const startPayment = async (
  locale,
  subscriptionType,
  israel,
  couponCode = null
) => {
  const params = new URLSearchParams({
    id: subscriptionType,
    israel: String(israel),
  })
  if (couponCode) {
    params.set('couponCode', couponCode)
  }
  const { data } = await axios.get(
    `/pay/start-payment/${locale}?${params.toString()}`
  )
  return data
}

export const cancelPayment = async paymentPublicId => {
  await axios.delete(`/pay/cancel-payment?paymentPublicId=${paymentPublicId}`)
}
